import { Button, Grid, Theme, makeStyles } from "@material-ui/core";
import { EditableCallbackParams } from "ag-grid-community";
import React from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

const useStyles = makeStyles((theme: Theme) => ({
	buttons: {},
}));

export const buttonsCellRenderer = (params: any) => {
	const classes = useStyles();

	const {
		setUserId,
		setOpenModalEditDataUser,
		setOpenModalDeleteUser,
		setOpenModalChangePasswordd,
		showContextMenu,
	} = params;

	return (
		<Grid
			container
			style={{
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
			className={classes.buttons}
		>
			<Grid
				item
				xs={12}
				md={12}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Button
					size="small"
					style={{ minWidth: 36, padding: 4 }}
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalChangePasswordd(true);
						})();
					}}
				>
					<LockOutlinedIcon color="primary" fontSize="small" />
				</Button>
				<Button
					size="small"
					style={{ minWidth: 36, padding: 4 }}
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalEditDataUser(true);
						})();
					}}
				>
					<EditIcon color="primary" fontSize="small" />
				</Button>
				<Button
					size="small"
					style={{ minWidth: 36, padding: 4 }}
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalDeleteUser(true);
						})();
					}}
				>
					<DeleteIcon color="secondary" fontSize="small" />
				</Button>
				<Button
					size="small"
					style={{ minWidth: 36, padding: 4 }}
					onClick={(e) => {
						showContextMenu(e, params.data, "TableUsers");
					}}
				>
					<FormatListBulletedSharpIcon color="action" fontSize="small" />
				</Button>
			</Grid>
		</Grid>
	);
};
